<template>
   <div class="container">
      <div class="video-warp">
        <div v-if="isLive">
          <video ref="liveStreamRef" id="mdplayer"></video>
        </div>
        <div v-else>
          <VideoPlayer
            :id="'mdplayer' + type"
            ref="playBackRef"
            type="application/x-mpegURL"
            v-if="m3u8"
            :src="m3u8"
            :controls="false"
            autoplay
            @volume-change="volumechange"
            @muted-change="mutedchange"
            @ended="ended"
            max-width="800px"
            max-height="450px"
          />
        </div>
      </div>
      <div>
        <legend style="font-size: 20px; font-weight: bold; margin-left:20px">功能, 經由 {{ AccessType }} 連線</legend>
        <div v-if="isPlayback" class="rowDiv contentCenter mt-1">
            <v-text-field label="開始時間 (時間格式:2024-01-01 23:59:59)" dense hide-details outlined filled v-model="starttime" color="black" class="mb-2" style="width:350px"></v-text-field>
            <v-text-field label="結束時間 (時間格式:2024-01-01 23:59:59)" dense hide-details outlined filled v-model="endtime"   color="black" class="mb-2" style="width:350px"></v-text-field>
        </div>
      </div>
      <div v-if="isPlayback">
        <v-select
          v-model="channel"
          label="Channel" 
          class="my-2"
          :items="channelList"
          :readonly="!allowChannelModify"
          dense hide-details outlined filled 
        />

        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="startPlayback">開始回放</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="stopPlayback">停止回放</v-btn>
        <v-btn depressed v-if="!isPause" color="success" class="btn_fontSize ml-2 my-2" @click="pausePlayback">暫停</v-btn>
        <v-btn depressed v-else color="success" class="btn_fontSize ml-2 my-2" @click="continuePlayback">繼續</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="resetSpeed">恢復</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="slowDown" :disabled="speed <= 0.125">慢放</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="fastForward" :disabled="speed >= 8">快放</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="download">下載</v-btn>
      </div>
      <div v-if="isLive">
        <v-select
          v-model="channel"
          label="Channel" 
          class="my-2"
          :items="channelList"
          :readonly="!allowChannelModify"
          dense hide-details outlined filled 
        />

        <div>
          <p>
            <v-icon v-if="liveStream" color="success">mdi-video</v-icon>
            <v-icon v-else color="error">mdi-video-off</v-icon>
            <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="startLive">開始串流</v-btn>
            <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="stopLive">停止串流</v-btn>
          </p>
          <p>
            <v-icon v-if="talk" color="success">mdi-account-voice</v-icon>
            <v-icon v-else color="error">mdi-microphone-off</v-icon>
            <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="startTalk">語音對講</v-btn>
            <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="stopTalk">停止對講</v-btn>
          </p>
        </div>


      </div>
    </div>
</template>

<script>
import VideoPlayer from '../components/VideoPlayer.vue'
export default {
  components: {
    VideoPlayer
  },
  data() {
    return {
      AccessType: null,
      storeParam: null,
      type: null,
      starttime: null,
      endtime: null,
      token: null,
      m3u8: null,
      channel: null,
      speed: 1,
      allowChannelModify: false,
      isPause: false,
      talk: null,
      liveStream: null,
      channelList: []
    };
  },
  computed: {
    isLive() {
      return this.type === 1
    },
    isPlayback() {
      return this.type === 0
    },
    isForward() {
      return this.port.startsWith(':9')
    }
  },
  watch: {
    speed() {
      this.$refs.playBackRef.setPlaybackRate(this.speed)
    }
  },
  created() {
    this.$emit('setAppbar', { isHide: true })
  },
  async mounted() {
    this.AccessType = this.$store.getters.getAccessType
    this.storeParam = this.$store.getters.getRouteParam
    this.$store.commit('setRouteParam', []);
    this.$store.commit('setAccessType', null);

    const [host, username, password, port, type, channel, start, end] = this.storeParam
    this.host = host
    this.port = `:${port}`
    this.username = username
    this.password = password
    this.starttime = start?.replace('T', ' ')
    this.endtime = end?.replace('T', ' ')
    this.type = type
    this.channel = channel

    if (!channel) {
      this.allowChannelModify = true
    }

    if (!this.AccessType && this.storeParam.length === 0) {
      this.$router.push('/Site_Info')
      return
    }

    if (this.isLive && channel) {
      this.$nextTick(() => {
        this.startLive()
      })
    }

    if (this.isPlayback) {
      this.$nextTick(() => {
        this.startPlayback()
      })
    }

    if (channel) {
      this.channelList = [channel]
      return
    }

    const channelList = await this.getDeviceChannel()

    this.channelList = channelList
      .filter(x => x.DeviceID)
      .map(x => x.Cam)
  },
  methods: {
    async getToken() {
      if (this.token) {
        return this.token
      }

      const auth = btoa(`${this.username}:${this.password}`)
      const base = `https://${this.host}`

      const token = await fetch(`${base}${this.port}/Config/Login`, {
        headers: {
          Authorization: `Basic ${auth}`
        }
      })
        .then(response => response.json())
        .then(([data]) => data.Token)

      return token
    },

    async startPlayback() {
      if (this.m3u8) {
        return this.$refs.palyBackRef.play()
      }
      
      const base = `https://${this.host}`
      const token = await this.getToken()

      await fetch(`${base}${this.port}/Config/playback/GetToken`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          Cam: `${this.channel}`,
          StartTime: this.starttime.replace(/[\D]/g, ''),
          EndTime: this.endtime.replace(/[\D]/g, '')
        })
      })
        .then(response => response.text())
        .then((text) => {
          if (text === 'failed') {
            throw text
          }

          return JSON.parse(text)
        })
        .then((data) => {
          if (data.err) {
            throw data.err
          }

          this.m3u8 = `${base}${this.port}${data.url}`
        })
        .catch(err => alert(err))

      this.token = token
    },

    stopPlayback() {
      this.m3u8 = null
    },

    pausePlayback() {
      this.isPause = true
      this.$refs.playBackRef?.pause()
    },

    continuePlayback() {
      this.isPause = false
      this.$refs.playBackRef?.play()
    },

    fastForward() {
      if (this.speed < 8) {
        this.speed *= 2
      }
    },

    slowDown() {
      if (this.speed > 0.125) {
        this.speed /= 2
      }
    },

    resetSpeed() {
      this.speed = 1
    },

    async isCameraConnect() {
      const token = await this.getToken()
      const res = await fetch(`https://${this.host}${this.port}/Config/GetCamInfo`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          Cam: `${this.channel}`
        })
      })

      if (!res.ok) {
        // TODO: error
      }

      const data = await res.json()

      const [info] = data
      const { IsConnect } = info

      return IsConnect === '1'
    },

    async startLive() {
      if (this.liveStream) {
        return
      }

      this.liveStream = {
      }

      const token = await this.getToken()

      const connect = this.isCameraConnect()
      if (!connect) {
        return ;
      }

      const url = this.isForward
        ? `https://${this.host}${this.port}/rtc/v1/whep/?app=live&stream=${this.channel}-1&token=${token}&eip=${this.host}:${this.port}`
        : `https://${this.host}${this.port}/rtc/v1/whep/?app=live&stream=${this.channel}-1&token=${token}`

      const el = this.$refs.liveStreamRef

      if (!el) {
        console.error('[VideoPlayer] <video> not found')
        return
      }

      const pc = new RTCPeerConnection({ iceServers: [] })

      pc.oniceconnectionstatechange = () => void null
      pc.onconnectionstatechange = () => void null

      pc.ontrack = (e) => {
        el.srcObject = e.streams[0];
      };

      pc.addTransceiver("video", { direction: "recvonly" });
      pc.addTransceiver("audio", { direction: "recvonly" });

      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);

      await (new Promise((resolve) => {
        const onChange = () => {
          if (pc.iceGatheringState === "complete") {
            pc.removeEventListener("icegatheringstatechange", onChange);
            resolve();
          }
        }
        pc.addEventListener("icegatheringstatechange", onChange);
      }))

      const resp = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/sdp", "Accept": "application/sdp" },
        body: pc.localDescription.sdp
      });

      if (!resp.ok) {
        console.error(resp)
        pc.close();
        return;
      }

      const answerSdp = await resp.text();
      const portNum = this.port.slice(1)
      const patchedSdp = answerSdp.replace(
        /^(a=candidate:.*\s)(\d+)(\s+typ\s+\S+)/gm,
        (match, prefix, _candidatePort, suffix) => {
          if (!this.isForward) {
            return match
          }

          const newPort = portNum.slice(0, -1) + '0'
          return `${prefix}${newPort}${suffix}`
        }
      )

      await pc.setRemoteDescription({ type: "answer", sdp: patchedSdp });

      try {
        await el.play(); 
      }
      catch (e) {
        console.error(e)
      }

      this.liveStream.pc = pc
    },

    stopLive() {
      this.m3u8 = null
      this.$refs.liveStreamRef.srcObject = null

      if (!this.liveStream) {
        return
      }
      
      if (this.liveStream.pc) {
        this.liveStream.pc.close();
      }

      this.liveStream = null
    },

    async startTalk() {
      if (!this.isLive) {
        return ;
      }

      if (this.talk) {
        return ;
      }

      const connect = this.isCameraConnect()
      if (!connect) {
        return ;
      }

      this.talk = {
        src: null,
        pc: null,
        stream: null
      }

      const stream = await navigator.mediaDevices.getUserMedia({ 
        audio: true,
        video: false,
      });

      const pc = new RTCPeerConnection({ iceServers: [] })

      this.talk.stream = stream
      this.talk.pc = pc

      pc.oniceconnectionstatechange = () => {
        const state = pc.iceConnectionState;
        if (state === 'failed' || state === 'disconnected') {
          this.stopTalk();
        }
      };

      stream.getTracks().forEach(track => pc.addTrack(track, stream));

      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);

      const token = await this.getToken()
      const url = `https://${this.host}${this.port}/rtc/v1/whip/?app=talk&stream=${this.channel}-1&token=${token}`
      const resp = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/sdp' },
        body: pc.localDescription.sdp
      });

      if (!resp.ok) {
        this.stopTalk();
        return;
      }

      let location = resp.headers.get('Location');
      let body = await resp.text();

      if (!location || !body) {
        this.stopTalk();
        return;
      }

      location = location.startsWith('http')
        ? location
        : `https://${this.host}${this.port}${location}`

      await pc.setRemoteDescription({ type: 'answer', sdp: body });

      this.talk.src = location
      this.talk.sdp = body
    },

    async stopTalk() {
      if (!this.talk) {
        return ;
      }

      const { src, pc, stream } = this.talk

      if (src) {
        await fetch(src, { method: "DELETE" })
      }

      if (pc) {
        pc.close();
      }

      if (stream) {
        stream.getTracks().forEach(track => track.stop())
      }

      this.talk = null
    },

    volumechange() { console.log('volumechange'); },
    mutedchange() { console.log('mutedchange'); },
    ended () { console.log('ended'); },

    async download() {
      const url = `https://${this.host}${this.port}/Config/VideoClip`
      const token = await this.getToken()

      const v = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          Cam: '' + this.channel,
          Index: "0",
          StartTime: this.starttime,
          EndTime: this.endtime
        })
      })

      const blob = await v.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = `video_${this.channel}_${Date.now()}.mp4`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(downloadUrl)

    },
    async getDeviceChannel() {
      const token = await this.getToken()
      const url = `https://${this.host}${this.port}/Config/GetCamInfo`

      const resp = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })

      return await resp.json()
    }
  },
};
</script>

<style scoped>

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.video-warp {
  width: 800px;
  aspect-ratio: 16 / 9;
  background: #4C4B4B;
  border: 1px solid rgb(255, 204, 0);
}

.video-warp video {
  width: 100%;
  height: 100%;
}
</style>
